export const TYPE = [
  {
    _id: 'digital-call-deflection-appointment-management',
    label: 'Appointment Management',
  },
  {
    _id: 'digital-call-deflection-billing',
    label: 'Billing',
  },
  {
    _id: 'digital-call-deflection-current-patient-menu',
    label: 'Current Patient Menu',
  },
  {
    _id: 'digital-call-deflection-directions',
    label: 'Directions',
  },
  {
    _id: 'digital-call-deflection-error',
    label: 'Error',
  },
  {
    _id: 'digital-call-deflection-landline-menu',
    label: 'Landline Menu',
  },
  {
    _id: 'digital-call-deflection-main-menu',
    label: 'Main Menu',
  },
  {
    _id: 'digital-call-deflection-medical-records',
    label: 'Medical Records',
  },
  {
    _id: 'digital-call-deflection-new-patient-menu',
    label: 'New Patient Menu',
  },
  {
    _id: 'digital-call-deflection-patient-verification',
    label: 'Patient Verification',
  },
  {
    _id: 'digital-call-deflection-redirect',
    label: 'Redirect',
  },
  {
    _id: 'digital-call-deflection-refills',
    label: 'Refills',
  },
  {
    _id: 'digital-call-deflection-scheduling',
    label: 'Scheduling',
  },
  {
    _id: 'digital-call-deflection-staff-chat',
    label: 'Staff Chat',
  },
  {
    _id: 'digital-call-deflection-staff-questions',
    label: 'Staff Questions',
  },
  {
    _id: 'digital-call-deflection-sub-menu',
    label: 'Sub Menu',
  },
];
